import api from 'api/apiInstance';

export function clientEstateSummaryViewApi(path: string) {
  return {
    path,
    POST: () => api.post(path),
  };
}
